import { render, staticRenderFns } from "./price-catalog.vue?vue&type=template&id=39c1aadc"
import script from "./price-catalog.vue?vue&type=script&lang=js"
export * from "./price-catalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports